<template>
    <v-app id="inspire" style="height: 100%; width: 100%; background-image: url('/bckAlumno.png'); background-repeat: no-repeat; background-position: right bottom 1%; background-color:#E3F2FD">
        <v-container fluid class="pa-0">
            <v-row align="start" justify="start">
                <v-col cols="12" sm="12" md="3" lg="3" class="pa-0 pl-5 pb-1 pr-2">
                    <v-row>
                        <v-col cols="12" class="pa-1">
                            <CPriAlumnoSearch @fuPriAlumnoChange="fuPriAlumnoChange" />
                        </v-col>
                        <v-col cols="12" class="pa-0">
                            <CPriAlumnoCabecera v-if="dPriAlumno" :pPriAlumno="dPriAlumno"/>
                        </v-col>
                        <v-col v-if="dPriAlumno" cols="12" class="pa-0">
                            <v-menu rounded offset-y>
                                <template v-slot:activator="{ attrs, on }">
                                    <v-btn color="blue-grey" class="white--text ma-0" v-bind="attrs" v-on="on" block rounded><v-icon>menu</v-icon> Matricula</v-btn>
                                </template>
                                <v-list>
                                    <v-list-item class="pa-0">
                                        <v-list-item-title>
                                            <v-btn @click.prevent="fuMatricular" rounded block color="success" dark>Regular, Reinicio o Repitencia</v-btn>
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item class="pa-0">
                                        <v-list-item-title>
                                            <v-btn @click.prevent="dModalMatriculaPorCurso.dialog = true; dCondicionMat='POR CURSO'" rounded block color="warning" dark>Por Curso</v-btn>
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item class="pa-0">
                                        <v-list-item-title>
                                            <v-btn @click.prevent="dModalMatriculaPorCurso.dialog = true; dCondicionMat='DIRIGIDO'" rounded block color="purple" dark>Dirigido</v-btn>
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                            <CMatMatriculaListByIdAlumno v-if="dPriAlumno" :pIdAlumno="parseInt(dPriAlumno.IdAlumno)" @pIdSeccion="fuIdSeccion" ref="refMatMatriculaListByIdAlumno"/>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="9" lg="9" class="pa-0 pl-2">
                    <v-tabs v-model="dTab">
                        <v-tab :value="1"><v-icon left>account_tree</v-icon>Secciones</v-tab>
                        <v-tab :value="2" v-if="dPriAlumno"><v-icon left>attach_money</v-icon>Económico</v-tab>
                        <v-tab :value="3" v-if="dPriAlumno"><v-icon left>tag</v-icon> Nota Final</v-tab>
                        <v-tab :value="4" v-if="dPriAlumno" @click="fuIframeShow('#idNota')"><v-icon left>tag</v-icon>Nota Detalle</v-tab>
                        <v-tab :value="5" v-if="dPriAlumno"><v-icon left>sort</v-icon>Ordenar Pagos</v-tab>
                        <v-tab :value="6" v-if="dPriAlumno"><v-icon left>poll</v-icon>Reporte</v-tab>
                        <v-tab-item>
                            <CMatSeccionMatricula  ref="refMatSeccionMatricula" @fuIdAlumnoChange="fuIdAlumnoChange" @fuMatriculaList="fuMatriculaList"/>
                        </v-tab-item>
                        <v-tab-item>
                            <CResumenPago v-if="dPriAlumno" :pIdAlumno="dPriAlumno.IdAlumno"/>
                        </v-tab-item>
                        <v-tab-item>
                            <CMatCursosMinisterioEgresado v-if="dPriAlumno" :pIdAlumno="parseInt(dPriAlumno.IdAlumno)" />
                        </v-tab-item>
                        <v-tab-item>
                            <iframe id="idNota" :src="cUrlNota" style="width: 100% !important; height: 5000px;" />
                        </v-tab-item>
                        <v-tab-item>
                            <CVsColeProyCuota v-if="dPriAlumno" :pCodigo="dPriAlumno.Codigo"/>
                        </v-tab-item>
                        <v-tab-item>
                            <CReporte v-if="dPriAlumno" :pIdAlumno="parseInt(dPriAlumno.IdAlumno)" />
                        </v-tab-item>
                    </v-tabs>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog v-model="dModalMatricular.dialog" max-width="1000">
            <v-card>
                <v-card-title class="blue-grey">
                    Matricular
                    <v-spacer></v-spacer>
                    <v-btn @click="dModalMatricular.dialog = false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="pa-0">
                    <CMatriculaByAlumno v-if="dPriAlumno" :pIdAlumno="parseInt(dPriAlumno.IdAlumno)" @fuMatriculaList="fuMatriculaList"/>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dModalMatriculaPorCurso.dialog" max-width="500">
            <v-card>
                <v-card-title class="white--text" :class="dCondicionMat === 'DIRIGIDO' ? 'purple' : 'warning'" >
                    {{dCondicionMat}}
                    <v-spacer></v-spacer>
                    <v-btn @click="dModalMatriculaPorCurso.dialog = false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="px-3 pb-0">
                    <CMatriculaPorCursoByAlumno v-if="dPriAlumno" :pIdAlumno="parseInt(dPriAlumno.IdAlumno)" :pCondicionMat="dCondicionMat" @fuMatriculaList="fuMatriculaList"/>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-app>
</template>
<script>
import gql from 'graphql-tag';
import CPriAlumnoSearch from '@/components/PRI/PriAlumnoSearch.vue';
import CPriAlumnoCabecera from '@/components/PRI/PriAlumnoCabecera.vue';
import CVsColeProyCuota from '@/components/Navasoft/VsColeProyCuota.vue';
import CMatriculaByAlumno from '@/components/Academico/MatriculaByAlumno.vue';
import CMatriculaPorCursoByAlumno from '@/components/Academico/MatriculaPorCursoByAlumno.vue';
import CMatMatriculaListByIdAlumno from '@/components/Academico/MatMatriculaListByIdAlumno.vue';
import CMatSeccionMatricula from '@/components/Academico/MatSeccionMatricula.vue';
import CMatCursosMinisterioEgresado from '@/components/Academico/MatCursosMinisterioEgresado.vue';
import CResumenPago from '@/components/Ing/ResumenPago.vue';
import CReporte from '@/components/Reporte/AlumnoByIdAlumno.vue';

export default {
    name: 'Matricula',
    components: {CPriAlumnoSearch, CPriAlumnoCabecera, CMatMatriculaListByIdAlumno, CMatSeccionMatricula, CMatriculaByAlumno, CMatriculaPorCursoByAlumno, CMatCursosMinisterioEgresado, CResumenPago, CReporte, CVsColeProyCuota},
    mounted(){
        //this.fuIdAlumnoChange(56711); //por curso: 51305, aller 63747
    },
    data: () => ({
        dPriAlumno: null,
        dTab: null,
        dModalMatricular: {
            dialog: false,
        },
        dModalMatriculaPorCurso: {
            dialog: false,
        },
        dCondicionMat: '',
    }),
    computed: {
        cUrlNota: function () {
            if(this.dPriAlumno)
                return 'https://intranetiframe.khipu.edu.pe/fichaSeguimientoNotas/' + this.dPriAlumno.IdAlumno;
        },
    },
    methods: {
        fuMatriculaList(){
            this.$refs.refMatMatriculaListByIdAlumno.fuLoad();
            this.dModalMatricular.dialog = false;
            this.dModalMatriculaPorCurso.dialog = false;
        },
        fuIframeShow(vId){
            setTimeout(() => {
                if (typeof window.iFrameResize !== 'undefined') window.iFrameResize({log: false}, vId)
            }, 1000);
        },
        fuPriAlumnoChange(p_Alumno) {
            this.dPriAlumno = p_Alumno;
        },
        fuIdSeccion(p_IdSeccion){
            this.$refs.refMatSeccionMatricula.fuIdSeccion(p_IdSeccion);
        },
        fuMatricular(){
            this.dModalMatricular.dialog = true;
        },
        async fuIdAlumnoChange(p_IdAlumno) {
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumno($IdAlumno: ID!, $token: String){
                        prialumno(IdAlumno:$IdAlumno, token: $token){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            Celular
                            IdServicio
                            priservicio{
                                Iniciales
                                Descripcion
                            }
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: p_IdAlumno,
                        token: new Date().toISOString()
                    }
                })
                this.dPriAlumno = response.data.prialumno;
            } catch (error) {
                console.log(error);
            } finally {
            }
        },
    },
}
</script>
